import { FunctionComponent, useEffect, useState } from "react";
import { format } from "date-fns";
import { ApolloError, useLazyQuery, useMutation } from "@apollo/client";
import ioniconaaddoutline from "../../assets/dashboard/ioniconaaddoutline.svg";
import ioniconttimeoutline from "../../assets/dashboard/ioniconttimeoutline.svg";
import ioniconttimeoutline1 from "../../assets/dashboard/ioniconttimeoutline-1.svg";
import icon from "../../assets/dashboard/icons-1.svg";
import icon1 from "../../assets/dashboard/icons3.svg";
import iioniconaalertcircleoutline from "../../assets/dashboard/ioniconaalertcircleoutline-1.svg";
import { useAuth } from "../../context/AuthContext";
import { DASHBOARD_COUNTERS, TODAY_CLOCK_IN } from "../../api/query";
import { employeeUrl } from "../../context/ApolloClient";
import Meetings from "../../components/dashboard/Meetings";
import Alerts from "../../components/dashboard/Alerts";
import DashAlert from "../../components/dashboard/DashAlert";
import TaskList from "../../components/dashboard/TaskList";
import { CREATE_BREAK } from "../../api/mutation";
import Popup from "../../components/dashboard/Popup";
import { useNavigate } from "react-router-dom";
import { showError, showSuccess } from "../../components/common/ToastNotification";
import SkeletonLoader from "../../components/common/SkeletonLoader";
import { getSupabaseExt } from "../../lib/supabase";

const Dashboard: FunctionComponent = () => {
    const now = new Date();
    const todayDate = format(now, "yyyy-MM-dd");

    const navigate = useNavigate()
    // const { userInfo } = useContext<any>(UserContext);
    const { userInfo, logout } = useAuth()
    const agencyId = userInfo?.agencies?.id;
    const employeeID = userInfo?.employee_id
    const userUUID = userInfo?.uuid;
    const [currentDate, setCurrentDate] = useState(
        format(new Date(), "MMM dd, yyyy")
    );
    const [clockInPopup, setClockInPopup] = useState(false)
    // const history = useHistory();

    const [buttonLabel, setButtonLabel] = useState("Dependency");
    const [isButtonClicked, setIsButtonClicked] = useState(true);
    const [demoCount, setDemoCount] = useState<any>(0)

    //api
    const [
        getTodayClockIn,
        { data: todayClockInData, loading: todayClockInLoading, error },
    ] = useLazyQuery(TODAY_CLOCK_IN, {
        fetchPolicy: 'no-cache'
    });

    const [createBreak, { loading: createBreakLoading }] = useMutation(CREATE_BREAK, {
        fetchPolicy: 'no-cache',
    })

    const [getDashCounters, { data: dashCounterData, loading: dashCounterDataLoading, refetch }] = useLazyQuery(DASHBOARD_COUNTERS, {
        fetchPolicy: 'no-cache'
    })


    if (error) {
        if ((error.message.includes("Session has expired. Please login again.")) || (error.message.includes("Unauthorized access, please login again."))) {
            showError(error.message)
            logout();
            navigate('/')
        }
    }

    async function fetchDemoPage() {
        const { count, error } = await getSupabaseExt()
            .from("carebravosite_contact_demo_requests")
            .select("*", { count: "exact", head: true })
            .is("meeting_detail", null)
            .eq("is_resolve", false);

        if (error) {
            console.error(error);
            return;
        }

        setDemoCount(count ?? 0);
    }

    useEffect(() => {
        fetchDemoPage()
    }, [])

    useEffect(() => {
        if (employeeID && agencyId) {
            getTodayClockIn({
                variables: {
                    employee_id: parseInt(employeeID),
                    agency_id: parseInt(agencyId)
                }
            })

            getDashCounters({
                variables: {
                    agency_id: parseInt(agencyId),
                    date: todayDate,
                }
            })
        }

        if (dashBtnlabel) {
            setButtonLabel(dashBtnlabel);
            setIsButtonClicked(true);
        }

    }, [employeeID, agencyId])

    const dashBtnlabel = localStorage.getItem("dashBoardActionOrAlert");

    function handleButtonClick(label: string) {
        localStorage.setItem("dashBoardActionOrAlert", label);
        setButtonLabel(label);
        setIsButtonClicked(true);
    }

    function handleClick() {
        alert("Your Searched text is submitted");
    }

    async function handlePopupClose() {
        setClockInPopup(false)
        await getTodayClockIn({
            variables: {
                employee_id: parseInt(employeeID),
                agency_id: parseInt(agencyId)
            }
        })
    }

    async function handleBreakInClick(clockInID: string) {
        const now = new Date();
        const pad = (n: any) => String(n).padStart(2, "0");
        const localTime = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}T${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}.000Z`;

        const breakData = {
            clock_in_id: parseInt(clockInID),
            start_time: localTime,
            agencies_id: parseInt(agencyId),
            created_by: parseInt(employeeID),
            is_break_in: "break_in"
        }

        try {
            const response = await createBreak({ variables: { input: breakData } });
            if (response.data.create_breaks.status_code === 201) {
                showSuccess(response.data.create_breaks.message)

                await getTodayClockIn({
                    variables: {
                        employee_id: parseInt(employeeID),
                        agency_id: parseInt(agencyId)
                    }
                })

                await getDashCounters({
                    variables: {
                        agency_id: parseInt(agencyId),
                        date: todayDate,
                    }
                })
                // navigate('/dashboard')
            }
            if (response.data.create_breaks.status_code === 400) {
                showError(response.data.create_breaks.message)
            }
        } catch (error) {
            if (error instanceof ApolloError) {
                showError(error.message)
            }
        }
    }

    async function handleBreakOutClick(clockInID: string, id: string) {
        const now = new Date();
        const pad = (n: any) => String(n).padStart(2, "0");
        const localTime = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}T${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}.000Z`;

        const breakData = {
            id: parseInt(id),
            clock_in_id: parseInt(clockInID),
            end_time: localTime,
            agencies_id: parseInt(agencyId),
            updated_by: parseInt(employeeID),
            is_break_in: "break_out"
        }

        try {
            const response = await createBreak({ variables: { input: breakData } });
            if (response.data.create_breaks.status_code === 201) {
                showSuccess(response.data.create_breaks.message)

                await getTodayClockIn({
                    variables: {
                        employee_id: parseInt(employeeID),
                        agency_id: parseInt(agencyId)
                    }
                })

                await getDashCounters({
                    variables: {
                        agency_id: parseInt(agencyId),
                        date: todayDate,
                    }
                })
                // navigate('/dashboard')
            }
            if (response.data.create_breaks.status_code === 400) {
                showError(response.data.create_breaks.message)
            }
        } catch (error) {
            if (error instanceof ApolloError) {
                showError(error.message)
            }
        }
    }

    return (
        <>
            <div id="cts-respon-p-dv" className="w-full relative themebg-cts-blg  overflow-hidden flex flex-col items-start py-40 justify-start min-w-full max-w-full tracking-[normal] leading-[normal] text-left text-xl text-colors-text-black font-body-xs-semi-bold mq450:max-w-full mq950:max-w-full mq1425:max-w-full mq1900:max-w-full">
                <div className="self-stretch overflow-hidden flex flex-row flex-wrap items-start justify-center px-20 mq575:px-5 box-border max-w-full mq950:pt-[34px] mq950:pb-[34px] mq950:box-border mq1425:box-border">
                    <div className="w-full flex flex-col items-start justify-start gap-[20px] max-w-full mq1425:max-w-full">
                        <div className="self-stretch flex flex-row items-start justify-start gap-[16px] max-w-full mq1425:flex-wrap">
                            <h3 className="m-0 h-[27px] flex-1 relative text-inherit font-bold font-inherit inline-block min-w-[82px] max-w-full mq450:text-base">
                                Dashboard
                            </h3>

                            {todayClockInLoading || createBreakLoading ? (
                                <div className="w-[150px]">
                                    <SkeletonLoader count={1} height="h-[44px]" borderRadius="rounded-radiuscomponent-button" />
                                </div>
                            ) : todayClockInData?.today_clock_in_out?.clock_in?.length > 0 ? (
                                (() => {
                                    const breaks = todayClockInData?.today_clock_in_out?.breaks || [];
                                    const latestBreak = breaks.length > 0 ? breaks[0] : null;
                                    const isOnBreak = latestBreak?.is_break_in === 'break_in' && !latestBreak?.end_time;

                                    if (isOnBreak) {
                                        const breakId = latestBreak?.id;

                                        // 🔴 Currently on break → Show Break Out only
                                        return (
                                            <button
                                                className="cursor-pointer [border:none] py-2.5 h-[44px] px-[42px] mq575:h-[35px] mq575:py-[12.5px] mq575:px-[25px] bg-yellow-500 rounded-radiuscomponent-button flex flex-row items-center justify-center gap-[12px] hover:bg-yellow-600"
                                                type="button"
                                                onClick={() => handleBreakOutClick(todayClockInData?.today_clock_in_out?.clock_in[0]?.id, breakId)}
                                            >
                                                <div className="relative text-sm font-body-xs-semi-bold text-white text-center inline-block">
                                                    Break Out
                                                </div>
                                            </button>
                                        );
                                    } else {
                                        // ✅ Clocked in, not on break → Show Clock Out + Break In
                                        return (
                                            <>
                                                <button
                                                    className="red-clockout-btn red-clockout-btn-items cursor-pointer [border:none] [border:none] py-2.5 h-[44px] px-[42px] mq575:h-[35px] mq575:py-[12.5px] mq575:px-[25px] bg-green-500 rounded-radiuscomponent-button flex flex-row items-center justify-center gap-[12px] "
                                                    type="button"
                                                    onClick={() =>
                                                        navigate('/clock_out', {
                                                            state: {
                                                                todayClockInData: todayClockInData?.today_clock_in_out?.clock_in[0],
                                                            },
                                                        })
                                                    }
                                                >
                                                    <div className="relative text-sm font-body-xs-semi-bold text-surface-bg-primary text-center inline-block">
                                                         <span className="ml-2">Clock Out</span>
                                                    </div>
                                                </button>

                                                <button
                                                    className="cursor-pointer green-clockin-button-item [border:none] py-2.5 h-[44px] px-[42px] mq575:h-[35px] mq575:py-[12.5px] mq575:px-[25px] bg-green-500 rounded-radiuscomponent-button flex flex-row items-center justify-center gap-[12px] hover:bg-green-600"
                                                    type="button"
                                                    onClick={() => handleBreakInClick(todayClockInData?.today_clock_in_out?.clock_in[0]?.id)}
                                                >
                                                    <div className="relative text-sm font-body-xs-semi-bold text-white text-center inline-block">
                                                        Break In
                                                    </div>
                                                </button>
                                            </>
                                        );
                                    }
                                })()
                            ) : (
                                // 🔵 No clock-in yet → Show Clock In
                                <button
                                    className="cursor-pointer [border:none] py-2.5 h-[44px] px-[42px] mq575:h-[35px] mq575:py-[12.5px] mq575:px-[25px] bg-surface-primary-surface rounded-radiuscomponent-button flex flex-row items-center justify-center gap-[12px] hover:bg-dodgerblue"
                                    type="button"
                                    onClick={() => setClockInPopup(true)}
                                >
                                    <div className="relative text-sm font-body-xs-semi-bold text-surface-bg-primary text-center inline-block">
                                        Clock In
                                    </div>
                                </button>
                            )}
                        </div>


                        <div
                            className={`self-stretch flex flex-row flex-wrap items-start justify-start py-0 pr-0 pl-0 box-border gap-[20px_18px] max-w-full text-left text-base text-dimgray font-body-xs-semi-bold`}
                        >
                            {clockInPopup && (
                                <Popup
                                    isOpen={clockInPopup}
                                    onClose={handlePopupClose}
                                    refetch={() => { }}
                                />
                            )}
                            <div
                                id="dash-leftbar"
                                className="flex-1 flex flex-col items-start justify-start gap-[20px] min-w-[328px] max-w-[328px]"
                            >
                                <Meetings
                                    currentDate={currentDate}
                                    ioniconaaddoutline={ioniconaaddoutline}
                                    // handleAddMeeting={() => { }}
                                    ioniconttimeoutline={ioniconttimeoutline}
                                    ioniconttimeoutline1={ioniconttimeoutline1}
                                    icon={icon}
                                    icon1={icon1}
                                    userUUID={userUUID}
                                    employeeUrl={employeeUrl}
                                    agencyId={agencyId}
                                    employeeId={employeeID}
                                />
                                <div className="alertliste-items-heading darktheme_card-dv bg self-stretch shadow-[0px_1px_4px_rgba(0,_0,_0,_0.2)] rounded-radius-md1 bg-surface-bg-primary flex flex-col items-start justify-start  text-surface-error">
                                    <div className="self-stretch alertlightdoc-tabel-head-dv flex flex-row items-center justify-start py-[19px] px-4 box-border max-w-full  dark:bg-slate-600">
                                        <b className="flex-1 text-xl-dv relative text-black inline-block max-w-[calc(100%_-_34px)] dark:text-white">Alerts</b>
                                    </div>
                                    <div className="grid p-4 gap-[8px] w-[294px] mq991:w-full max-w-[294px]">
                                        {dashCounterDataLoading ? (
                                            <div className="flex flex-col gap-2 w-full">
                                                {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
                                                    <div key={i} className="flex justify-between items-center p-2 border border-surface-border rounded bg-surface-bg-primary">
                                                        <div className="flex gap-2 items-center w-full">
                                                            <SkeletonLoader count={1} height="h-2.5" width="w-4" borderRadius="rounded-full" />
                                                            <SkeletonLoader count={1} height="h-2.5" width="w-1/2" />
                                                        </div>
                                                        <SkeletonLoader count={1} height="h-5" width="w-5" borderRadius="rounded-full" />
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <>
                                                <Alerts
                                                    iONIconAalertcircleoutlin={iioniconaalertcircleoutline}
                                                    button="Dependency"
                                                    showIONIconAalertcircleoutlin
                                                    iONIconAalertcircleoutlinVisible
                                                    isHighlighted={buttonLabel === "Dependency"}
                                                    onButtonClick={handleButtonClick}
                                                    alertCountNumber={dashCounterData?.dashboard_counters?.dashboard_counters?.dependencies_count || 0}
                                                />
                                                <Alerts
                                                    iONIconAalertcircleoutlin={iioniconaalertcircleoutline}
                                                    button="Delays"
                                                    showIONIconAalertcircleoutlin
                                                    iONIconAalertcircleoutlinVisible
                                                    isHighlighted={buttonLabel === "Delays"}
                                                    onButtonClick={handleButtonClick}
                                                    alertCountNumber={dashCounterData?.dashboard_counters?.dashboard_counters?.delays_count || 0}
                                                />
                                                <Alerts
                                                    iONIconAalertcircleoutlin={iioniconaalertcircleoutline}
                                                    button="Defect"
                                                    showIONIconAalertcircleoutlin
                                                    iONIconAalertcircleoutlinVisible
                                                    isHighlighted={buttonLabel === "Defect"}
                                                    onButtonClick={handleButtonClick}
                                                    alertCountNumber={dashCounterData?.dashboard_counters?.dashboard_counters?.defects_count || 0}
                                                />
                                                <Alerts
                                                    iONIconAalertcircleoutlin={iioniconaalertcircleoutline}
                                                    button="Demo Request"
                                                    showIONIconAalertcircleoutlin
                                                    iONIconAalertcircleoutlinVisible
                                                    isHighlighted={buttonLabel === "Demo Request"}
                                                    onButtonClick={handleButtonClick}
                                                    alertCountNumber={demoCount}
                                                />
                                                <Alerts
                                                    iONIconAalertcircleoutlin={iioniconaalertcircleoutline}
                                                    button="Upcoming Features"
                                                    showIONIconAalertcircleoutlin
                                                    iONIconAalertcircleoutlinVisible
                                                    isHighlighted={buttonLabel === "Upcoming Features"}
                                                    onButtonClick={handleButtonClick}
                                                    alertCountNumber={dashCounterData?.dashboard_counters?.dashboard_counters?.upcoming_feature_counts || 0}
                                                />
                                                <Alerts
                                                    iONIconAalertcircleoutlin={iioniconaalertcircleoutline}
                                                    button="Today's Leave"
                                                    showIONIconAalertcircleoutlin
                                                    iONIconAalertcircleoutlinVisible
                                                    isHighlighted={buttonLabel === "Today's Leave"}
                                                    onButtonClick={handleButtonClick}
                                                    alertCountNumber={dashCounterData?.dashboard_counters?.dashboard_counters?.today_leave_counts || 0}
                                                />
                                                <Alerts
                                                    iONIconAalertcircleoutlin={iioniconaalertcircleoutline}
                                                    button="Upcoming Leave"
                                                    showIONIconAalertcircleoutlin
                                                    iONIconAalertcircleoutlinVisible
                                                    isHighlighted={buttonLabel === "Upcoming Leave"}
                                                    onButtonClick={handleButtonClick}
                                                    alertCountNumber={dashCounterData?.dashboard_counters?.dashboard_counters?.next_seven_days_leave_counts || 0}
                                                />
                                                <Alerts
                                                    iONIconAalertcircleoutlin={iioniconaalertcircleoutline}
                                                    button="Breaks"
                                                    showIONIconAalertcircleoutlin
                                                    iONIconAalertcircleoutlinVisible
                                                    isHighlighted={buttonLabel === "Breaks"}
                                                    onButtonClick={handleButtonClick}
                                                    alertCountNumber={dashCounterData?.dashboard_counters?.dashboard_counters?.breaks_count || 0}
                                                />
                                                <Alerts
                                                    iONIconAalertcircleoutlin={iioniconaalertcircleoutline}
                                                    button="Bugs"
                                                    showIONIconAalertcircleoutlin
                                                    iONIconAalertcircleoutlinVisible
                                                    isHighlighted={buttonLabel === "Bugs"}
                                                    onButtonClick={handleButtonClick}
                                                    alertCountNumber={dashCounterData?.dashboard_counters?.dashboard_counters?.bugs_count || 0}
                                                />
                                                <Alerts
                                                    iONIconAalertcircleoutlin={iioniconaalertcircleoutline}
                                                    button="Enhancements"
                                                    showIONIconAalertcircleoutlin
                                                    iONIconAalertcircleoutlinVisible
                                                    isHighlighted={buttonLabel === "Enhancements"}
                                                    onButtonClick={handleButtonClick}
                                                    alertCountNumber={dashCounterData?.dashboard_counters?.dashboard_counters?.enhancements_count || 0}
                                                />
                                                {/* <Alerts
                                                    iONIconAalertcircleoutlin={iioniconaalertcircleoutline}
                                                    button="Follow Up"
                                                    showIONIconAalertcircleoutlin
                                                    iONIconAalertcircleoutlinVisible
                                                    isHighlighted={buttonLabel === "Follow Up"}
                                                    onButtonClick={handleButtonClick}
                                                    alertCountNumber={dashCounterData?.dashboard_counters?.dashboard_counters?.follow_up_count || 0}
                                                />     */}
                                                 <Alerts
                                                    iONIconAalertcircleoutlin={iioniconaalertcircleoutline}
                                                    button="Training Issue"
                                                    showIONIconAalertcircleoutlin
                                                    iONIconAalertcircleoutlinVisible
                                                    isHighlighted={buttonLabel === "Training Issue"}
                                                    onButtonClick={handleButtonClick}
                                                    alertCountNumber={dashCounterData?.dashboard_counters?.dashboard_counters?.training_issue_count || 0}
                                                />
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div
                                id="dash-center-dv"
                                className="flex-1 flex flex-col items-start justify-start gap-[20px] min-w-[398px] text-main-blue mq450:min-w-full mq950:max-w-full"
                            >
                                <TaskList isAddBtnDisable={todayClockInData && todayClockInData?.today_clock_in_out?.clock_in?.length > 0} />
                                <div className="darktheme_card-dv alert_action_tbl_dv self-stretch shadow-[2px_2px_32px_rgba(0,_19,_85,_0.08)] rounded-lg bg-surface-bg-primary box-border overflow-hidden flex flex-col items-start justify-start max-w-full text-surface-error border-[1px] border-solid border-surface-border">
                                    {isButtonClicked && (
                                        <DashAlert alertLabel={buttonLabel} refetchCounter={refetch} />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default Dashboard;
